/**
 * Converts plain-text URLs in an HTML string to clickable <a> tags.
 * Skips URLs that are already inside an existing <a> tag (href or anchor text).
 */
export function linkifyUrls(html: string): string {
    if (!html) return html;

    // Split on existing anchor tags to avoid double-wrapping
    // Captures full <a ...>...</a> blocks as separate segments
    const parts = html.split(/(<a\b[^>]*>.*?<\/a>)/gi);

    return parts
        .map((part) => {
            // If this segment is an existing anchor tag, leave it alone
            if (/^<a\b/i.test(part)) return part;

            // Replace plain-text URLs with anchor tags
            return part.replace(
                /\bhttps?:\/\/[^\s<>"']+/gi,
                (url) =>
                    `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
            );
        })
        .join('');
}
